import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('appheader');

export { TAG_NAME };
